import { useIntl } from "react-intl";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import ContentLoading from "component/LoadingComponent/ContentLoading.js";
import { useProfileForm } from "./useProfileForm";
import ProfileForm from "./components/ProfileForm";

function Profile() {
  const intl = useIntl();
  const {
    id,
    dir,
    control,
    errors,
    isLoading,
    onSubmit,
    buttonSpinner,
    snackbar,
  } = useProfileForm();

  return (
    <ContentLoading isLoading={isLoading}>
      <div className="subscribe">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "profile" }),
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "profile-data" })}
          route={"../profile"}
        />
        <div className="container py-5">
          <div className="row">
            <div className="col-12 col-lg-9">
              <ProfileForm
                id={id}
                dir={dir}
                control={control}
                errors={errors}
                onSubmit={onSubmit}
                buttonSpinner={buttonSpinner}
                snackbar={snackbar}
              />
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default Profile;
